export const APP_CONTENT_ID = 'app-content';
